"use strict";

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}
jQuery(document).ready(function () {
  jQuery('#osg-preorder-form').on('submit', function (event) {
    event.preventDefault();
    // Check for Receipt Number

    if (jQuery('#osg-preorder-form-subscriber-receipt').val()) {
      var useSSL = 'https:' == document.location.protocol;
      var userSubscribe = 1;
      if (typeof jQuery(".osg-preorder-form-newsletter-opt-in input:checkbox:checked").val() == 'undefined') {
        userSubscribe = 0;
      }
      var preOrderResponse = "";
      if (jQuery('#osg-preorder-form-subscriber-email').val()) {
        jQuery.ajax({
          url: book_js.ajaxurl,
          method: 'POST',
          type: 'post',
          dataType: 'json',
          cache: false,
          data: {
            action: "osg_preorder_bundle",
            nonce: book_js.nonce,
            email: jQuery('#osg-preorder-form-subscriber-email').val(),
            newsletter_subscribe: userSubscribe,
            name: jQuery('#inputName').val()
          },
          beforeSend: function () {
            jQuery('#osg-preorder-form-result').fadeOut(500);
            jQuery('#osg-preorder-form-result').html('');
            jQuery('.osg-preorder-form-mailchimp .form-floating, .osg-preorder-form-mailchimp .osg-preorder-form-newsletter-opt-in, .osg-preorder-form-mailchimp button').fadeOut(500);
          },
          error: function (xhr, status, error) {
            jQuery('.osg-preorder-form-mailchimp .form-floating, .osg-preorder-form-mailchimp .osg-preorder-form-newsletter-opt-in, .osg-preorder-form-mailchimp button').fadeIn(500);
            preOrderResponse = '<div class="alert alert-danger" role="alert">' + (error !== null && error !== void 0 ? error : 'Server Error: Please try again later.') + '</div>';
          },
          success: function (obj) {
            if (obj.response == "success") {
              if (obj.subscription_message) {
                preOrderResponse = '<div class="alert alert-success" role="alert">' + obj.subscription_message + '</div>';
              }
              preOrderResponse += '<div class="alert alert-primary" role="alert">Thank you for ordering! We\'ve emailed you the bonus bundle directly so you won\'t lose it, but you can also click the link below to download it now. If you’re not receiving the email, try adding “preorder@ohsheglows.com” to your safe-sender list (or Contacts) so the email gets through any spam filters. Then you can resubmit this form for the email to be sent again.<br /><br /><a href="' + obj.download_url + '" download="OSG_Salads_Bonus_Bundle.pdf" style="margin-left:20px; font-weight:800;" onclick="javascript:ga(\'send\', \'event\', \'OSG Salads Bonus Bundle\', \'download\', \'Pre-order\');">Oh She Glows Salads Bonus Bundle</a></div>';
            } else if (obj.response == "failure") {
              if (obj.download_url) {
                preOrderResponse = '<div class="alert alert-primary" role="alert"><div class="alert alert-danger" role="alert">' + obj.error + '</div>Thank you for pre-ordering! You can click the link below to download the pre-order bundle now.<br /><br /><a href="' + obj.download_url + '" download="OSG_Salads_Bonus_Bundle.pdf" style="margin-left:20px; font-weight:800;" onclick="javascript:ga(\'send\', \'event\', \'OSG Salads Bonus Bundle\', \'download\', \'Pre-order\');">Oh She Glows Salads Bonus Bundle</a></div>';
              } else {
                var _obj$error;
                jQuery('.osg-preorder-form-mailchimp .form-floating, .osg-preorder-form-mailchimp .osg-preorder-form-newsletter-opt-in, .osg-preorder-form-mailchimp button').fadeIn(500);
                preOrderResponse = '<div class="alert alert-danger" role="alert">' + ((_obj$error = obj.error) !== null && _obj$error !== void 0 ? _obj$error : 'Server Error: Please try again later.') + '</div>';
              }
            } else {
              preOrderResponse = '<div class="alert alert-danger" role="alert">Server Error: Please try again later.</div>';
            }
          },
          complete: function () {
            jQuery('#osg-preorder-form-result').html(preOrderResponse);
            jQuery('#osg-preorder-form-result').fadeIn(500);
          }
        });
      }
    } else {
      //Show Error
      jQuery('#osg-preorder-form-subscriber-receipt').addClass('is-invalid');
      jQuery('#osg-preorder-form-result').html('<div class="alert alert-danger" role="alert">Please enter your order number.</div>');
      jQuery('#osg-preorder-form-result').fadeIn(500);
    }
  });
  jQuery('#osg-preorder-form-subscriber-email').on('input', function () {
    if (jQuery(this)[0].checkValidity()) {
      jQuery(this).removeClass('is-invalid');
    } else {
      jQuery(this).addClass('is-invalid');
    }
  });
  jQuery('#osg-preorder-form-subscriber-receipt').on('input', function () {
    jQuery('#osg-preorder-form-subscriber-receipt').removeClass('is-invalid');
  });
  jQuery('#book4-order-btn').on('click', function () {
    setHash("#book4-retailers");
  });
  jQuery('#book3-order-btn').on('click', function () {
    setHash("#book3-retailers");
  });
  jQuery('#book2-order-btn').on('click', function () {
    setHash("#book2-retailers");
  });
  jQuery('#book1-order-btn').on('click', function () {
    setHash("#book1-retailers");
  });
  get_country_code();

  // Pe Slider    
  var quoteSlider = new peSlider();
  quoteSlider.init({
    slider: '#quotes-slider',
    pagination: false,
    navigation: false,
    afterChange: function () {
      var slide = quoteSlider.activeSlide().number + 1;
      document.querySelector('.quotes-navigation').dataset.current = '0' + slide;
    }
  });
  var qPrev = document.getElementById('q-prev');
  var qNext = document.getElementById('q-next');
  qNext.addEventListener('click', function () {
    quoteSlider.nextSlide();
  });
  qPrev.addEventListener('click', function () {
    quoteSlider.prevSlide();
  });
  Array.prototype.slice.call(document.querySelectorAll('.form-group input')).forEach(function (inputEl) {
    if (inputEl.value.trim() !== '') {
      inputEl.parentNode.classList.add('block');
    }
    inputEl.addEventListener('focus', onInputFocus);
    inputEl.addEventListener('blur', onInputBlur);
  });
  function onInputFocus(ev) {
    ev.target.parentNode.classList.add('block');
  }
  function onInputBlur(ev) {
    if (ev.target.value.trim() === '') {
      ev.target.parentNode.classList.remove('block');
    }
  }
});
function change_brand_icons(country_code) {
  switch (country_code) {
    case "CA":
      jQuery('.book1-apple-books-link').attr('href', 'https://books.apple.com/ca/book/the-oh-she-glows-cookbook/id965707856?mt=11&itsct=books_toolbox&itscg=30200&at=1000ld8w&ct=bookpage');
      jQuery('.book2-apple-books-link').attr('href', 'https://books.apple.com/ca/book/oh-she-glows-every-day/id1065532468?mt=11&itsct=books_toolbox&itscg=30200&at=1000ld8w&ct=bookpage');
      jQuery('.book3-apple-books-link').attr('href', 'https://books.apple.com/ca/book/oh-she-glows-for-dinner/id1511407204?mt=11&itsct=books_toolbox&itscg=30200&at=1000ld8w&ct=bookpage');
      jQuery('.book4-apple-books-link').attr('href', 'https://books.apple.com/ca/book/oh-she-glows-salads/id6748626861?mt=11&itsct=books_toolbox&itscg=30200&at=1000ld8w&ct=bookpage');
      jQuery('.book1-kindle-link').attr('href', 'https://amzn.to/46OtmdW');
      jQuery('.book2-kindle-link').attr('href', 'https://amzn.to/41w2dc3');
      jQuery('.book3-kindle-link').attr('href', 'https://amzn.to/45H3fEs');
      jQuery('.book4-kindle-link').attr('href', 'https://amzn.to/3JnchxH');
      jQuery('#book1cover').attr('src', book_js.plugin_url + 'images/book_page/OhSheGlowsCookbook_CAN_Cover_new.jpg');
      jQuery('#book1-brand-icons-bg').css('background-color', '#92d4ec');
      jQuery('#book1-retailers').css('background-color', '#92d4ec');
      jQuery('#book1-features .feature-title').attr('style', 'color:#ee3b47');
      jQuery('#cookbook1-title-text').addClass('canada');
      jQuery('.book1-feature-icons').each(function () {
        jQuery(this).attr('src', jQuery(this).attr('src').replace('036720', '92d4ec')); //.load(function(){ this.width; });;
      });
      jQuery('#book1-order-btn').on('mouseenter', function () {
        jQuery(this).addClass('book1-order-btn-hover-can');
      }).on('mouseleave', function () {
        jQuery(this).removeClass('book1-order-btn-hover-can');
      });
      jQuery('#book1-order-btn').on('focus', function () {
        jQuery(this).addClass('book1-order-btn-hover-can');
      }).on('blur', function () {
        jQuery(this).removeClass('book1-order-btn-hover-can');
      });
      jQuery('#book1-order-btn').css({
        'background-color': '#fff',
        'color': '#92d4ec',
        'border-color': '#92d4ec'
      });
      var css = '#thebook1 .btn-orange:hover, #thebook1 .btn-orange:focus { color: #fff !important; background-color: #ee3b47 !important; }';
      var style = document.createElement('style');
      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
      document.getElementsByTagName('head')[0].appendChild(style);
      jQuery('#book1-store-icons').html('<div class="brand-icon"><a href="https://amzn.to/3hH8sAC" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/amazon.png" width="250px" alt="Purchase the Oh She Glows Cookbook from Amazon" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://www.indigo.ca/products/the-oh-she-glows-cookbook?variant=46165517041841" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/indigo.png" width="250px" alt="Purchase the Oh She Glows Cookbook from Indigo" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://books.apple.com/ca/book/the-oh-she-glows-cookbook/id965707856?mt=11&itsct=books_toolbox&itscg=30200&at=1000ld8w" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/ibooks.png" width="250px" alt="Purchase the Oh She Glows Cookbook from Apple iBooks" data-pin-nopin="1"></a></div>');
      jQuery('#book2-store-icons').html('<div class="brand-icon"><a href="https://www.amazon.ca/gp/product/0143196510/ref=as_li_qf_sp_asin_tl?ie=UTF8&camp=15121&creative=330641&creativeASIN=0143196510&linkCode=as2&tag=ohshgl0c-20" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/amazon.png" width="250px" alt="Purchase Oh She Glows Every Day from Amazon" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://www.indigo.ca/products/oh-she-glows-every-day?variant=46165517205681" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/indigo.png" width="250px" alt="Purchase Oh She Glows Every Day from Indigo" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://books.apple.com/ca/book/oh-she-glows-every-day/id1065532468?mt=11&itsct=books_toolbox&itscg=30200&at=1000ld8w" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/ibooks.png" width="250px" alt="Purchase Oh She Glows Every Day from Apple iBooks" data-pin-nopin="1"></a></div>');
      jQuery('#book3-store-icons').html('<div class="brand-icon"><a href="https://amzn.to/3f9ANO4" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/amazon.png" width="250px" alt="Purchase Oh She Glows for Dinner from Amazon" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://www.indigo.ca/products/oh-she-glows-for-dinner?variant=46154942906545" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/indigo.png" width="250px" alt="Purchase Oh She Glows for Dinner from Indigo" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://books.apple.com/ca/book/oh-she-glows-for-dinner/id1511407204?mt=11&itsct=books_toolbox&itscg=30200&at=1000ld8w" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/ibooks.png" width="250px" alt="Purchase Oh She Glows for Dinner from Apple iBooks" data-pin-nopin="1"></a></div>');
      jQuery('#book4-store-icons').html('<div class="brand-icon"><a href="https://amzn.to/4le9QuD" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/rgb/amazon.png" width="250px" alt="Purchase Oh She Glows Salads from Amazon" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://www.indigo.ca/products/oh-she-glows-salads?variant=46235475673298" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/rgb/indigo.png" width="250px" alt="Purchase Oh She Glows Salads from Indigo" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://books.apple.com/ca/book/oh-she-glows-salads/id6748626861?mt=11&itsct=books_toolbox&itscg=30200&at=1000ld8w" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/rgb/ibooks-preorder.png" width="250px" alt="Purchase Oh She Glows Salads from Apple iBooks" data-pin-nopin="1"></a></div>');
      break;
    case "UK":
    case "GB":
    case "GBR":
    case "IE":
    case "IRL":
      jQuery('.book1-apple-books-link').attr('href', 'https://books.apple.com/gb/book/oh-she-glows/id967468996?itsct=books_toolbox&itscg=30200&at=1000ld8w&ct=bookpage');
      jQuery('.book2-apple-books-link').attr('href', 'https://books.apple.com/gb/book/oh-she-glows-every-day/id1165661512?itsct=books_toolbox&itscg=30200&at=1000ld8w&ct=bookpage');
      jQuery('.book3-apple-books-link').attr('href', 'https://books.apple.com/gb/book/oh-she-glows-for-dinner/id1511407529?ign-itscg=30200&ign-itsct=books_toolbox&ct=bookpage');
      jQuery('.book4-apple-books-link').attr('href', 'https://books.apple.com/gb/book/oh-she-glows-salads/id6748626861?mt=11&itsct=books_toolbox&itscg=30200&at=1000ld8w&ct=bookpage');
      jQuery('.book1-kindle-link').attr('href', 'https://www.amazon.co.uk/Oh-She-Glows-Angela-Liddon-ebook/dp/B00TKZ70FE?&linkCode=ll1&tag=ohshgl-20&linkId=c2e4816660f6342c42fcee98d8e39044&language=en_GB&ref_=as_li_ss_tl');
      jQuery('.book2-kindle-link').attr('href', 'https://www.amazon.co.uk/Oh-She-Glows-Every-Day-ebook/dp/B01M8INIC9?&linkCode=ll1&tag=ohshgl-20&linkId=89affb13790002ee1d184643be403d90&language=en_GB&ref_=as_li_ss_tl');
      jQuery('.book3-kindle-link').attr('href', 'https://www.amazon.co.uk/She-Glows-Dinner-Nourishing-Plant-Based-ebook/dp/B08819BPJB?&linkCode=ll1&tag=ohshgl-20&linkId=ded085343ff9c36a727fdd5a4f170491&language=en_GB&ref_=as_li_ss_tl');
      jQuery('.book4-kindle-link').attr('href', 'https://www.amazon.co.uk/She-Glows-Salads-Protein-Packed-Plant-Based-ebook/dp/B0FHJQ4J82?&linkCode=ll1&tag=ohshgl-20&linkId=279d5e1b14a7c75417b6abb1cc6034d0&language=en_GB&ref_=as_li_ss_tl');
      jQuery('#book1-store-icons').html('<div class="brand-icon"><a href="https://amzn.to/3g8KGNA" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/amazon.png" width="250px" alt="Purchase the Oh She Glows Cookbook from Amazon" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://www.waterstones.com/book/the-oh-she-glows-cookbook/angela-liddon/9781583335277" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/waterstones_300x155.png" width="250px" alt="Purchase the Oh She Glows Cookbook from Waterstones" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://books.apple.com/gb/book/oh-she-glows/id967468996?itsct=books_toolbox&itscg=30200&at=1000ld8w" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/ibooks.png" width="250px" alt="Purchase the Oh She Glows Cookbook from Apple iBooks" data-pin-nopin="1"></a></div>');
      jQuery('#book2-store-icons').html('<div class="brand-icon"><a href="https://amzn.to/3g6YJTA" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/amazon.png" width="250px" alt="Purchase Oh She Glows Every Day from Amazon" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://www.waterstones.com/book/oh-she-glows-every-day/angela-liddon/9780718184582" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/waterstones_300x155.png" width="250px" alt="Purchase Oh She Glows Every Day from Waterstones" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://books.apple.com/gb/book/oh-she-glows-every-day/id1165661512?itsct=books_toolbox&itscg=30200&at=1000ld8w" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/ibooks.png" width="250px" alt="Purchase Oh She Glows Every Day from Apple iBooks" data-pin-nopin="1"></a></div>');
      jQuery('#book3-store-icons').html('<div class="brand-icon"><a href="https://amzn.to/2WW2DHx" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/amazon.png" width="250px" alt="Purchase Oh She Glows for Dinner from Amazon" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://www.waterstones.com/book/oh-she-glows-for-dinner/angela-liddon/9780593083673" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/waterstones_300x155.png" width="250px" alt="Purchase Oh She Glows for Dinner from Waterstones" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://books.apple.com/gb/book/oh-she-glows-for-dinner/id1511407529?itsct=books_toolbox&itscg=30200&at=1000ld8w" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/ibooks.png" width="250px" alt="Purchase Oh She Glows for Dinner from Apple iBooks" data-pin-nopin="1"></a></div>');
      jQuery('#book4-store-icons').html('<div class="brand-icon"><a href="https://amzn.to/4njCzje" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/rgb/amazon.png" width="250px" alt="Purchase Oh She Glows Salads from Amazon" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://www.waterstones.com/book/oh-she-glows-salads/angela-liddon/9780735250215" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/rgb/waterstones_300x155.png" width="250px" alt="Purchase Oh She Glows Salads from Waterstones" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://books.apple.com/gb/book/oh-she-glows-salads/id6748626861?mt=11&itsct=books_toolbox&itscg=30200&at=1000ld8w" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/rgb/ibooks-preorder.png" width="250px" alt="Purchase Oh She Glows Salads from Apple iBooks" data-pin-nopin="1"></a></div>');
      break;
    case "AU":
      jQuery('.book1-apple-books-link').attr('href', 'https://books.apple.com/au/book/the-oh-she-glows-cookbook/id921807204?itsct=books_toolbox&itscg=30200&at=1000ld8w&ct=bookpage');
      jQuery('.book2-apple-books-link').attr('href', 'https://books.apple.com/au/book/oh-she-glows-every-day/id1165661512?itsct=books_toolbox&itscg=30200&at=1000ld8w&ct=bookpage');
      jQuery('.book3-apple-books-link').attr('href', 'https://books.apple.com/au/book/oh-she-glows-for-dinner/id1511407529?itsct=books_toolbox&itscg=30200&at=1000ld8w&ct=bookpage');
      jQuery('.book4-apple-books-link').attr('href', 'https://books.apple.com/au/book/oh-she-glows-salads/id6748626861?mt=11&itsct=books_toolbox&itscg=30200&at=1000ld8w&ct=bookpage');
      jQuery('.book1-kindle-link').attr('href', 'https://www.amazon.com.au/Oh-She-Glows-Cookbook-Recipes-ebook/dp/B00NTPDJWE?&linkCode=ll1&tag=ohsheglows-22&linkId=f46475fa4d5202b5495527ba59737278&language=en_AU&ref_=as_li_ss_tl');
      jQuery('.book2-kindle-link').attr('href', 'https://www.amazon.com.au/Oh-She-Glows-Every-Day-ebook/dp/B01M8INIC9?&linkCode=ll1&tag=ohsheglows-22&linkId=48d18ae7811ae3a5aee4a56f119bce44&language=en_AU&ref_=as_li_ss_tl');
      jQuery('.book3-kindle-link').attr('href', 'https://www.amazon.com.au/She-Glows-Dinner-Nourishing-Plant-Based-ebook/dp/B08819BPJB?&linkCode=ll1&tag=ohsheglows-22&linkId=3324b68033867e9922fa805fb1ed1c31&language=en_AU&ref_=as_li_ss_tl');
      jQuery('.book4-kindle-link').attr('href', 'https://www.amazon.com.au/She-Glows-Salads-Protein-Packed-Plant-Based-ebook/dp/B0FHJQ4J82?&linkCode=ll1&tag=ohsheglows-22&linkId=f838d9a3bda2c21765a2c81b64f8ad16&language=en_AU&ref_=as_li_ss_tl');
      jQuery('#book1-store-icons').html('<div class="brand-icon"><a href="https://amzn.to/46dTzSk" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/amazon.png" width="250px" alt="Purchase the Oh She Glows Cookbook from Amazon" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://books.apple.com/gb/book/oh-she-glows/id967468996?itsct=books_toolbox&itscg=30200&at=1000ld8w" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/ibooks.png" width="250px" alt="Purchase the Oh She Glows Cookbook from Apple iBooks" data-pin-nopin="1"></a></div>');
      jQuery('#book2-store-icons').html('<div class="brand-icon"><a href="https://amzn.to/4gyVX9R" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/amazon.png" width="250px" alt="Purchase Oh She Glows Every Day from Amazon" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://books.apple.com/gb/book/oh-she-glows-every-day/id1165661512?itsct=books_toolbox&itscg=30200&at=1000ld8w" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/ibooks.png" width="250px" alt="Purchase Oh She Glows Every Day from Apple iBooks" data-pin-nopin="1"></a></div>');
      jQuery('#book3-store-icons').html('<div class="brand-icon"><a href="https://amzn.to/4gsrrOJ" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/amazon.png" width="250px" alt="Purchase Oh She Glows for Dinner from Amazon" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://books.apple.com/gb/book/oh-she-glows-for-dinner/id1511407529?itsct=books_toolbox&itscg=30200&at=1000ld8w" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/ibooks.png" width="250px" alt="Purchase Oh She Glows for Dinner from Apple iBooks" data-pin-nopin="1"></a></div>');
      jQuery('#book4-store-icons').html('<div class="brand-icon"><a href="https://amzn.to/4psxJBZ" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/rgb/amazon.png" width="250px" "Purchase Oh She Glows Salads from Amazon" data-pin-nopin="1"></a></div>' + '<div class="brand-icon"><a href="https://books.apple.com/au/book/oh-she-glows-salads/id6748626861?mt=11&itsct=books_toolbox&itscg=30200&at=1000ld8w" target="_blank"><img src="' + book_js.plugin_url + 'images/book_page/logos/rgb/ibooks-preorder.png" width="250px" "Purchase Oh She Glows Salads from Apple iBooks" data-pin-nopin="1"></a></div>');
      break;
    default:
      jQuery('#book1-order-btn').on('mouseenter', function () {
        jQuery(this).addClass('book1-order-btn-hover-us');
      }).on('mouseleave', function () {
        jQuery(this).removeClass('book1-order-btn-hover-us');
      });
      jQuery('#book1-order-btn').on('focus', function () {
        jQuery(this).addClass('book1-order-btn-hover-us');
      }).on('blur', function () {
        jQuery(this).removeClass('book1-order-btn-hover-us');
      });
      break;
  }
}
function get_country_code() {
  fetch('/cdn-cgi/trace').then(response => response.text()).then(data => {
    osgCountryCode = data.match(/loc=(\S+)/)[1];
    if (osgCountryCode == null) osgCountryCode = 'XX';
    change_brand_icons(osgCountryCode);
  });
}
function setHash(newHash) {
  location.hash = 'someHashThatDoesntExist';
  location.hash = newHash;
}

// Utility functions

function testColor(str) {
  var dummy = document.createElement('div');
  dummy.style.color = str;

  // Is the syntax valid?
  if (!dummy.style.color) {
    return null;
  }
  document.head.appendChild(dummy);
  var normalized = getComputedStyle(dummy).color;
  document.head.removeChild(dummy);
  if (!normalized) {
    return null;
  }
  var rgb = normalized.match(/\((\d+), (\d+), (\d+)/);
  return normalized; // for testing purposes
}
function SelectText(element) {
  var doc = document,
    text = element,
    range,
    selection;
  if (doc.body.createTextRange) {
    range = document.body.createTextRange();
    range.moveToElementText(text);
    range.select();
    /*
    if(range.toString().length === 0){
      range.moveToElementText(text);
      range.select();
    }
    */
  } else if (window.getSelection) {
    selection = window.getSelection();
    if (selection.toString().length === 0) {
      range = document.createRange();
      range.selectNodeContents(text);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }
}
var docElem = window.document.documentElement;
function getViewportH() {
  var client = docElem.clientHeight,
    inner = window.innerHeight;
  if (client < inner) {
    return inner;
  } else {
    return client;
  }
}
function scrollY() {
  return window.pageYOffset || docElem.scrollTop;
}
function getOffset(el) {
  var offsetTop = 0,
    offsetLeft = 0;
  do {
    if (!isNaN(el.offsetTop)) {
      offsetTop += el.offsetTop;
    }
    if (!isNaN(el.offsetLeft)) {
      offsetLeft += el.offsetLeft;
    }
  } while (el = el.offsetParent);
  return {
    top: offsetTop,
    left: offsetLeft
  };
}
function inViewport(el, h) {
  var elH = el.offsetHeight,
    scrolled = scrollY(),
    viewed = scrolled + getViewportH(),
    elTop = getOffset(el).top,
    elBottom = elTop + elH,
    h = h || 0;
  return elTop + elH * h <= viewed && elBottom - elH * h >= scrolled;
}
function getRadioVal(name) {
  var radioGroup = document.getElementsByName(name);
  for (var i = 0, length = radioGroup.length; i < length; i++) {
    if (radioGroup[i].checked) {
      return radioGroup[i].value;
    }
  }
}
function setRadioVal(name, value) {
  var radioGroup = document.getElementsByName(name);
  for (var i = 0, length = radioGroup.length; i < length; i++) {
    if (radioGroup[i].value == value) {
      radioGroup[i].checked = true;
    }
  }
}
function outerHeight(el) {
  var height = el.offsetHeight;
  var style = getComputedStyle(el);
  height += parseInt(style.marginTop) + parseInt(style.marginBottom);
  return height;
}
function outerWidth(el) {
  var width = el.offsetWidth;
  var style = getComputedStyle(el);
  width += parseInt(style.marginLeft) + parseInt(style.marginRight);
  return width;
}
(function () {
  function removeLoader(el, removeTime) {
    if (!el) return;
    el.classList.add("loaded");
    setTimeout(function () {
      // Try the expected parent, otherwise fall back safely
      var parent = document.querySelector("body main.gfp-fullpage-wrapper") || el.parentNode;
      if (parent && parent.contains(el)) parent.removeChild(el);
    }, removeTime);
  }
  function initPeLoader(opts) {
    var config = {
      loader: "#loading",
      removeTime: 700,
      autoRemoveDelay: 1000
    };
    if (opts) for (var k in opts) if (Object.prototype.hasOwnProperty.call(opts, k)) config[k] = opts[k];
    var el = document.querySelector(config.loader);
    if (!el) return; // nothing to do

    var timer;

    // Remove after full load (images/fonts/etc), after delay
    window.addEventListener("load", function () {
      timer = setTimeout(function () {
        removeLoader(el, config.removeTime);
      }, config.autoRemoveDelay);
    });

    // Optional: allow clicking the loader to dismiss
    el.addEventListener("click", function () {
      if (timer) clearTimeout(timer);
      removeLoader(el, config.removeTime);
    });
  }

  // IMPORTANT: if this file loads before DOM exists, wait for DOMContentLoaded
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initPeLoader({
        loader: "#loading",
        removeTime: 700
      });
    });
  } else {
    initPeLoader({
      loader: "#loading",
      removeTime: 700
    });
  }
})();
(function () {
  function getTarget() {
    var p = new URLSearchParams(window.location.search);
    return p.get("scroll");
  }
  function normalizeId(raw) {
    if (!raw) return null;
    // strip anything IG might append
    return raw.split("&")[0].trim();
  }
  function go() {
    var target = normalizeId(getTarget());
    if (!target) return;

    // 1) If fullPage.js (v3/v4) is controlling scroll, use its API
    // v4 instance commonly at: fullpage_api
    if (window.fullpage_api && typeof window.fullpage_api.moveTo === "function") {
      // Best case: you have anchors configured in fullPage.js matching your section name
      // moveTo(anchor) or moveTo(section, slide)
      window.fullpage_api.moveTo(target);
      return;
    }

    // 2) Otherwise, standard DOM scroll fallback
    var el = document.getElementById(target);
    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
      return;
    }

    // 3) Last resort: try name-based anchor
    var named = document.querySelector('[name="' + CSS.escape(target) + '"]');
    if (named) named.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }
  window.addEventListener("load", function () {
    // give your loader time (2s + 700ms) plus a little cushion
    setTimeout(go, 1800);
  });
})();